import styles from './Spinner.module.scss';

interface Props {
  align?: 'start' | 'center' | 'end';
  message?: string;
  position?: 'absolute' | 'relative';
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
}

export function Spinner(props: Props) {
  const { align = 'center', position = 'relative', size = 'medium' } = props;
  const className = [styles['spinner'], styles['spinner-size-' + size]]
    .filter(Boolean)
    .join(' ');
  const containerClassName = [
    styles['spinner-container'],
    styles['spinner-align-' + align],
    styles['spinner-position-' + position],
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={containerClassName}>
      <span aria-hidden="true" className={className} />
      {props.message && <span>{props.message}</span>}
    </div>
  );
}
